export const BINANCE_BASE_URL = "https://api.binance.com/api/v3/klines";
export const BINANCE_DEFAULT_SYMBOL = "BTCUSDT";
export const BINANCE_DEFAULT_INTERVAL = "1d";
export const BINANCE_DEFAULT_LIMIT = 180;
